// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.10.0",
  date: "2026-09-18T12:08:00.408Z",
  gitInfo: {
    dirty: false,
    raw: "f852c4562",
    hash: "f852c4562",
    distance: null,
    tag: null,
    semver: null,
    suffix: "f852c4562",
    semverString: null
  }
};
/* tslint:enable */
